import { render, staticRenderFns } from "./passwordModal.vue?vue&type=template&id=079c0cd4&lang=pug&"
import script from "./passwordModal.vue?vue&type=script&lang=js&"
export * from "./passwordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports